import { DashboardPage } from 'components/pages/Dashboard'

const Page = () => {
  return <DashboardPage />
}

export default Page
